import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import ProgressFullScreen from '../../../../components/Compartilhados/ProgressFullScreen';

export default function UsuarioProfileChangePassword(props) {
  const {
    open,
    setOpen,
    usuario,
    changePassword,
    senhaAtual,
    setSenhaAtual,
    novaSenha,
    setNovaSenha,
    replicaNovaSenha,
    setReplicaNovaSenha,
    mostrarSenhaAtual,
    setMostrarSenhaAtual,
    mostrarNovaSenha,
    setMostrarNovaSenha,
    mostrarReplicaNovaSenha,
    setMostrarReplicaNovaSenha
  } = props;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function validatorSenha() {
      ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        return value == novaSenha;
      });
    }
    validatorSenha()
  }, [replicaNovaSenha]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function onChangeReplicaNovaSenha(replica) {
    setReplicaNovaSenha(replica);
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
      return value == novaSenha;
    });
  }

  async function finalizeChangePassword() {
    await changePassword(senhaAtual, novaSenha, replicaNovaSenha);
  }

  return (
    <div>
      <ProgressFullScreen
        open={loading}
        setOpen={setLoading}
      />
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <ValidatorForm
          autoComplete="off"
          onSubmit={e => finalizeChangePassword()}
          onError={console.log('')}
        >
          <DialogTitle id="form-dialog-title">Mudança de senha</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography gutterBottom>
                Você está tentando alterar o usuário com as seguintes informações:
              </Typography>
              <Typography gutterBottom>
                {'Nome: ' + (usuario.nome || 'NÃO INFORMADO')}
              </Typography>
              <Typography gutterBottom>
                {'CPF: ' + (usuario.cpfCnpj || 'NÃO INFORMADO')}
              </Typography>
              <Typography gutterBottom>
                Por questões de segurança será necessário informar a senha atual do usuário e. Após isso, informe a nova senha.
              </Typography>
            </DialogContentText>

              <Grid
                container
                spacing={3}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <TextValidator
                    id="outlined-adornment-password"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={senhaAtual}
                    type={mostrarSenhaAtual ? 'text' : 'password'}
                    label="Informe a senha"
                    onChange={e => setSenhaAtual(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="toggle password visibility"
                            onClick={e => setMostrarSenhaAtual(!mostrarSenhaAtual)}
                          >
                            {mostrarSenhaAtual ? <VisibilityOff/> : <Visibility/>}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    helperText="Insira a atual senha de acesso ao sistema do usuario."
                    validators={['required']}
                    errorMessages={['Insira a atual senha de acesso ao sistema do usuario.', 'Senha muito curta!']}
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                >

                  <TextValidator
                    id="outlined-adornment-password"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={novaSenha}
                    type={mostrarNovaSenha ? 'text' : 'password'}
                    label="Nova senha"
                    onChange={e => setNovaSenha(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="toggle password visibility"
                            onClick={e => setMostrarNovaSenha(!mostrarNovaSenha)}
                          >
                            {mostrarNovaSenha ? <VisibilityOff/> : <Visibility/>}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    helperText="Insira a nova senha de acesso ao sistema."
                    validators={['required', 'minStringLength:6']}
                    errorMessages={['Insira a nova senha de acesso ao sistema.', 'Senha muito curta!']}
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <TextValidator
                    id="outlined-adornment-password"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={replicaNovaSenha}
                    type={mostrarReplicaNovaSenha ? 'text' : 'password'}
                    label="Repita a nova senha"
                    onChange={e => onChangeReplicaNovaSenha(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            aria-label="toggle password visibility"
                            onClick={e => setMostrarReplicaNovaSenha(!mostrarReplicaNovaSenha)}
                          >
                            {mostrarReplicaNovaSenha ? <VisibilityOff/> : <Visibility/>}
                          </IconButton>

                        </InputAdornment>
                      ),
                    }}
                    helperText="Insira a nova senha novamente."
                    validators={['required', 'isPasswordMatch']}
                    errorMessages={['Insira a nova senha novamente.', 'As senhas não são iguais!']}
                  />
                </Grid>

              </Grid>




          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button type={'submit'} color="primary">
              Continuar
            </Button>
          </DialogActions>
        </ValidatorForm>

      </Dialog>
    </div>
  );
}
